<div class="container sam-form-flex-row" (click)="onClick()">
   <button kendoButton look="flat" class="sam-full-width primary">
      <div class="sam-full-width sam-form-flex-row">
         <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
   </button>
</div>
<ng-template #content>
   <div class="sam-form-row" style="margin-bottom: 0; width: 100%">
      <div class="sam-form-flex-row sam-margin-top">
         <ng-container *ngTemplateOutlet="icon"></ng-container>
         <div class="sam-form-row sam-ellipsis-on-overflow sam-full-width" style="margin-bottom: 0">
            <div *ngIf="!isNameEmpty" class="name sam-ellipsis-on-overflow">
               {{ entry.orgnam }}
            </div>
            <div *ngIf="isNameEmpty" class="name sam-ellipsis-on-overflow">
               {{ 'brick.brick_definitions.directory_browser.empty_contact_details.name' | translate }}
            </div>
            <div *ngIf="!isNumberEmpty" class="number sam-ellipsis-on-overflow">
               {{ entry.orgnum }}
            </div>
            <div *ngIf="isNumberEmpty" class="number sam-ellipsis-on-overflow">
               {{ 'brick.brick_definitions.directory_browser.empty_contact_details.number' | translate }}
            </div>
         </div>
         <div
            *ngIf="areEditableEntriesChanged$ | async"
            class="sam-opacity-ligth sam-sub-font-size sam-warning sam-italic"
         >
            {{ 'brick.brick_definitions.directory_browser.edit_contact_details.value_edited' | translate }}
         </div>
      </div>
   </div>
</ng-template>

<ng-template #icon>
   <div class="sam-center sam-margin-right">
      <fa-icon [icon]="directoryIcon" [fixedWidth]="true" class="email-list-icon"></fa-icon>
   </div>
</ng-template>
